module.exports = __webpack_public_path__ + "static/img/lj_pic2.53bfc36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/lj_pic2.jpg
// module id = 92bV
// module chunks = 37